/* =========================================================================
   AP (AUTO PARTS) — Interactions for product page: gallery, qty, offer
   modal, text-us, copy OEM. Scoped per section via data-ap-product-root.
   ========================================================================= */
(function(){
  'use strict';

  // -- Toast ------------------------------------------------------------
  function ensureToast() {
    var t = document.getElementById('ap-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'ap-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(t);
    }
    return t;
  }
  var toastTimer;
  window.apToast = function(msg){
    var t = ensureToast();
    t.querySelector('span').textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 2800);
  };

  // -- Initialize each product section --------------------------------
  document.querySelectorAll('[data-ap-product-root]').forEach(function(root){
    initGallery(root);
    initQty(root);
    initCopyOem(root);
    initTextUs(root);
    initOfferModal(root);
    initStickyBuy(root);
    initTabs(root);
  });

  // -- Gallery ---------------------------------------------------------
  function initGallery(root){
    var main = root.querySelector('[data-ap-main-img]');
    var thumbs = root.querySelectorAll('[data-ap-thumb]');
    var counterCur = root.querySelector('[data-ap-counter-current]');
    var counterTotal = root.querySelector('[data-ap-counter-total]');
    if (!main || !thumbs.length) return;
    var srcs = Array.from(thumbs).map(function(t){ return t.dataset.src; });
    var current = 0;
    if (counterTotal) counterTotal.textContent = srcs.length;

    function setActive(i){
      current = (i + srcs.length) % srcs.length;
      main.src = srcs[current];
      var alt = thumbs[current].dataset.alt;
      if (alt) main.alt = alt;
      if (counterCur) counterCur.textContent = current + 1;
      thumbs.forEach(function(t, idx){ t.classList.toggle('active', idx === current); });
    }
    thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ setActive(i); }); });
    var prev = root.querySelector('[data-ap-gallery-prev]');
    var next = root.querySelector('[data-ap-gallery-next]');
    if (prev) prev.addEventListener('click', function(){ setActive(current - 1); });
    if (next) next.addEventListener('click', function(){ setActive(current + 1); });
    root._apSetActive = setActive;
    root._apGetCurrent = function(){ return current; };
    root._apSrcs = srcs;
  }

  // -- Quantity --------------------------------------------------------
  function initQty(root){
    var dec = root.querySelector('[data-ap-qty-dec]');
    var inc = root.querySelector('[data-ap-qty-inc]');
    var val = root.querySelector('[data-ap-qty-val]');
    if (!dec || !inc || !val) return;
    function clamp(n){ return Math.max(1, Math.min(99, n)); }
    inc.addEventListener('click', function(){ val.value = clamp(parseInt(val.value||'1', 10) + 1); });
    dec.addEventListener('click', function(){ val.value = clamp(parseInt(val.value||'1', 10) - 1); });
  }

  // -- Copy OEM --------------------------------------------------------
  function initCopyOem(root){
    var btn = root.querySelector('[data-ap-copy-oem]');
    if (!btn) return;
    btn.addEventListener('click', async function(e){
      e.preventDefault();
      var val = btn.dataset.oem;
      try {
        await navigator.clipboard.writeText(val);
        btn.classList.add('copied');
        var label = btn.querySelector('span');
        if (label) {
          var orig = label.textContent;
          label.textContent = 'Copied';
          setTimeout(function(){ label.textContent = orig; btn.classList.remove('copied'); }, 1600);
        } else {
          setTimeout(function(){ btn.classList.remove('copied'); }, 1600);
        }
        window.apToast(val + ' copied to clipboard');
      } catch(err) {
        window.apToast('Could not copy — long-press to select');
      }
    });
  }

  // -- Text Us ---------------------------------------------------------
  function initTextUs(root){
    var btns = root.querySelectorAll('[data-ap-text-us]');
    btns.forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var phone = btn.dataset.phone;
        var phoneDisplay = btn.dataset.phoneDisplay || phone;
        var msg = btn.dataset.message || 'Hi, I’m interested in this part. Could you confirm availability?';
        if (!phone) {
          window.apToast('A phone number has not been configured yet.');
          return;
        }
        var smsLink = 'sms:' + phone + '?&body=' + encodeURIComponent(msg);
        var a = document.createElement('a');
        a.href = smsLink;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.apToast('Opening messages — or text ' + phoneDisplay);
      });
    });
  }

  // -- Offer Modal -----------------------------------------------------
  function initOfferModal(root){
    var openBtn = root.querySelector('[data-ap-open-offer]');
    var modal = root.querySelector('[data-ap-offer-modal]');
    if (!openBtn || !modal) return;
    var form = modal.querySelector('#ap-offer-contact-form');
    var success = modal.querySelector('[data-ap-offer-success]');
    var formWrap = modal.querySelector('[data-ap-offer-form-wrap]');
    var submitBtn = modal.querySelector('[data-ap-offer-submit]');
    var formError = modal.querySelector('[data-ap-offer-form-error]');
    var bodyField = modal.querySelector('[data-ap-offer-body]');
    var askPrice = parseFloat(openBtn.dataset.askPrice || '0');

    function open(initial){
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (initial === 'success') {
        if (formWrap) formWrap.style.display = 'none';
        if (success) success.classList.add('show');
      } else {
        if (success) success.classList.remove('show');
        if (formWrap) formWrap.style.display = '';
      }
      if (formError) { formError.style.display = 'none'; formError.textContent = ''; }
      if (initial !== 'success') {
        setTimeout(function(){
          var first = modal.querySelector('[data-ap-field="offer-price"]');
          if (first) first.focus();
        }, 50);
      }
    }
    function close(){
      modal.classList.remove('open');
      document.body.style.overflow = '';
    }
    openBtn.addEventListener('click', function(){ open(); });
    modal.querySelectorAll('[data-ap-close-offer]').forEach(function(c){ c.addEventListener('click', close); });
    modal.addEventListener('click', function(e){ if (e.target === modal) close(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && modal.classList.contains('open')) close(); });

    // If we just came back from a successful Shopify contact-form POST,
    // open the modal straight into the success state and clean the URL.
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('contact_posted') === 'true' && params.get('ap_offer') === '1') {
        open('success');
        params.delete('contact_posted');
        params.delete('ap_offer');
        var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash;
        window.history.replaceState({}, '', newUrl);
      }
    } catch(_){}

    // Quick suggest buttons
    modal.querySelectorAll('[data-ap-suggest]').forEach(function(b){
      b.addEventListener('click', function(){
        var pct = parseFloat(b.dataset.apSuggest);
        var price = (askPrice * pct).toFixed(2);
        var field = modal.querySelector('[data-ap-field="offer-price"]');
        if (field) {
          field.value = price;
          field.classList.remove('err');
          var err = modal.querySelector('[data-ap-err="offer-price"]');
          if (err) err.textContent = '';
        }
      });
    });

    function setError(id, msg){
      var inp = modal.querySelector('[data-ap-field="'+id+'"]');
      var err = modal.querySelector('[data-ap-err="'+id+'"]');
      if (!inp || !err) return;
      if (msg) { inp.classList.add('err'); err.textContent = msg; }
      else { inp.classList.remove('err'); err.textContent = ''; }
    }
    function validEmail(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

    function showFormError(msg){
      if (!formError) return;
      formError.textContent = msg;
      formError.style.display = 'block';
    }

    function hiddenValue(name){
      var el = form && form.querySelector('input[name="'+name+'"]');
      return el ? el.value : '';
    }

    function buildBody(fields){
      var lines = [];
      lines.push('A customer has submitted an offer through usedoempartsfast.com.');
      lines.push('');
      lines.push('── OFFER ────────────────────────────────────────');
      lines.push('Product:       ' + hiddenValue('contact[Product]'));
      var oem = hiddenValue('contact[OEM Number]');
      if (oem) lines.push('OEM number:    ' + oem);
      var tagn = hiddenValue('contact[Tag Number]');
      if (tagn) lines.push('Tag number:    ' + tagn);
      lines.push('Asking price:  ' + hiddenValue('contact[Asking Price]'));
      lines.push('Offered price: $' + fields.price);
      lines.push('Product URL:   ' + hiddenValue('contact[Product URL]'));
      lines.push('Variant ID:    ' + hiddenValue('contact[Variant ID]'));
      lines.push('');
      lines.push('── CUSTOMER ─────────────────────────────────────');
      lines.push('Name:  ' + fields.name);
      lines.push('Email: ' + fields.email);
      if (fields.phone) lines.push('Phone: ' + fields.phone);
      if (fields.message){
        lines.push('');
        lines.push('── MESSAGE ──────────────────────────────────────');
        lines.push(fields.message);
      }
      lines.push('');
      lines.push('── SUBMITTED ────────────────────────────────────');
      lines.push(new Date().toString());
      return lines.join('\n');
    }

    if (!form || !submitBtn) return;

    // Validate + build body on submit, then let the browser POST natively.
    // Shopify's hCaptcha runs on the real native submission, then redirects
    // back to this product page with ?contact_posted=true&ap_offer=1 so the
    // modal re-opens in success state (handled above).
    form.addEventListener('submit', function(e){
      if (formError) { formError.style.display = 'none'; formError.textContent = ''; }

      var ok = true;
      var priceRaw = (modal.querySelector('[data-ap-field="offer-price"]').value || '').trim();
      var price = priceRaw.replace(/[^0-9.]/g,'');
      var name  = (modal.querySelector('[data-ap-field="offer-name"]').value  || '').trim();
      var email = (modal.querySelector('[data-ap-field="offer-email"]').value || '').trim();
      var phone = (modal.querySelector('[data-ap-field="offer-phone"]').value || '').trim();
      var msg   = (modal.querySelector('[data-ap-field="offer-msg"]').value   || '').trim();

      if (!price || !isFinite(parseFloat(price)) || parseFloat(price) <= 0) { setError('offer-price', 'Please enter a valid offer amount.'); ok = false; } else setError('offer-price','');
      if (!name)  { setError('offer-name',  'Please enter your name.'); ok = false; } else setError('offer-name','');
      if (!email) { setError('offer-email', 'Please enter your email.'); ok = false; }
      else if (!validEmail(email)) { setError('offer-email', 'That email doesn’t look right.'); ok = false; }
      else setError('offer-email','');

      // Honeypot: silently reject bots
      var honey = form.querySelector('input[name="contact[honey]"]');
      if (honey && honey.value) { e.preventDefault(); return; }

      if (!ok) { e.preventDefault(); return; }

      if (bodyField){
        bodyField.value = buildBody({
          price: parseFloat(price).toFixed(2),
          name: name, email: email, phone: phone, message: msg
        });
      }

      // Loading state (page will reload / redirect, but button should look busy)
      if (submitBtn){
        submitBtn.disabled = true;
        submitBtn.classList.add('is-busy');
        var label = submitBtn.querySelector('.ap-btn-label');
        if (label) label.textContent = 'Sending…';
      }
      // Allow native submit → Shopify handles captcha + redirects back
    });
  }

  // -- Sticky mobile buy bar ------------------------------------------
  function initStickyBuy(root){
    var bar = root.querySelector('[data-ap-sticky-buy]');
    var hero = root.querySelector('[data-ap-main-img]');
    if (!bar || !hero) return;
    function update(){
      if (window.innerWidth > 900) { bar.style.display = 'none'; return; }
      var rect = hero.getBoundingClientRect();
      bar.style.display = rect.bottom < 20 ? 'flex' : 'none';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  // -- Tabs ------------------------------------------------------------
  function initTabs(root){
    var tabBtns = root.querySelectorAll('[data-ap-tab]');
    if (!tabBtns.length) return;
    tabBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var target = btn.dataset.apTab;
        tabBtns.forEach(function(t){ t.classList.toggle('active', t === btn); t.setAttribute('aria-selected', t === btn); });
        root.querySelectorAll('[data-ap-panel]').forEach(function(p){
          p.classList.toggle('active', p.dataset.apPanel === target);
        });
      });
    });
  }

})();
